import { render, staticRenderFns } from "./CardScroller.vue?vue&type=template&id=994dcfce&"
import script from "./CardScroller.vue?vue&type=script&lang=js&"
export * from "./CardScroller.vue?vue&type=script&lang=js&"
import style0 from "./CardScroller.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports